var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',_vm._l((_vm.verticalTextConfigs),function(val,idx){return _c('VerticalText',{key:idx,attrs:{"text-config":val,"text-area-idx":idx,"is-visible":val.visible,"balloon-idx":val.balloonIdx}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }